import {
  AllSubstringsIndexStrategy,
  LowerCaseSanitizer,
  Search
} from "js-search";
import {type BoidAssignmentTableData} from "../model";
import {type SearchFunction} from "./SearchFunction";

export const buildSearch = (
  tableData: BoidAssignmentTableData[]
): SearchFunction => {
  const search = new Search<BoidAssignmentTableData>("key");
  search.indexStrategy = new AllSubstringsIndexStrategy();
  search.sanitizer = new LowerCaseSanitizer();
  search.addIndex("sourceCaId");
  search.addIndex("id");
  search.addIndex("type");
  search.addIndex("product");
  search.addIndex("operationalBoidStatus");
  search.addIndex("operationalBoidStatusLabel");
  search.addIndex("clientBoidStatus");
  search.addDocuments(tableData);

  return (query: string): BoidAssignmentTableData[] =>
    search.search(query).sort((a, b) => a.type.localeCompare(b.type) || a.id.localeCompare(b.id));
};
